import React from 'react';
import { Stack, Typography } from '@mui/material';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';

import { customUtils } from '../../utils';

// convert the date to standard
const DateConvert = ({ inputDateTime }) => {
    return customUtils.dateFormat(inputDateTime);
};

//covnert utc to  local time
const TimeConvert = ({ inputDateTime }) => {
    return customUtils.timeConvert(inputDateTime);
};

const VesselETA = ({ aisData }) => {
    const dateTime = aisData && aisData.Eta ? aisData.Eta : '';

    return (
        <>
            {(!aisData || aisData === '') && (
                <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                    <ErrorOutlineOutlined sx={{ height: '18px' }} />
                    <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                        Not Found
                        <Typography variant="caption" display="block">
                            Note: Unable to Get AIS ETA Data
                        </Typography>
                    </Stack>
                </Stack>
            )}

            {aisData && (
                <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                    <AccessTimeFilledIcon sx={{ height: '18px' }} />
                    <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                        {<DateConvert inputDateTime={dateTime} />}
                        <Typography variant="caption" display="block">
                            {<TimeConvert inputDateTime={dateTime} />}
                        </Typography>
                    </Stack>
                </Stack>
            )}
        </>
    );
};

export default VesselETA;
